import { transactionService } from '../../helpers/services/transaction.service';
import { sharedHelper, filtersHelper } from '@/utils'
import router from '@/router/index'

export const state = {
    list: {
        data: [],
        pagination: {
            pageNumber: 0,
            pageSize: 0,
            lastPage: 0,
            tableRowsCount: 0
        }
    },
    details: {},
    status: {}
}

export const TRANSACTION_MODULE = 'transaction'; 

// define action 
export const GET_ALL_TRANSACTIONS = 'getAllTransactions';
export const GET_TRANSACTION = 'getTransaction';

// define mutation
const SUCCESS = "commonSuccess";
const FAILURE = "commonFailure";
const REQUEST = "commonRequest";
const GET_ALL_TRANSACTIONS_REQUEST = "getAllTransactions";
const GET_TRANSACTION_REQUEST = "getTransaction";

export const actions = {
    // eslint-disable-next-line no-unused-vars
    [GET_ALL_TRANSACTIONS]({ commit }, { filter }) {
        transactionService
            .getAllTransactions(filter)
            .then(
                (result) => {
                    commit(GET_ALL_TRANSACTIONS_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            )
    },

    // eslint-disable-next-line no-unused-vars
    [GET_TRANSACTION]({ commit }, { id }) {
        transactionService
            .getTransaction(id)
            .then(
                (result) => {
                    commit(GET_TRANSACTION_REQUEST, result)
                },
                (error) => {
                    let message = sharedHelper.getErrorMessage(error);
                    sharedHelper.alertErrorMessage(message, error.response.data.code)
                }
            );
    },
};

export const mutations = {

    [SUCCESS](state) {
        state.status = {};
        router.push({ name: "Transaction-listing" });
    },
    [FAILURE](state) {
        state.status = {};
    },
    [REQUEST](state) {
        state.status = { update: true, create: true };
    },
    [GET_ALL_TRANSACTIONS_REQUEST](state, data) {
        let d = data.data

        state.list.pagination = sharedHelper.apiPaginationAdapter(data.pagination)

        state.list.data = d.map((o) => {
            return {
                uuid: o.uuid,
                paymentReferenceNumber: o.payment_reference_number,
                transactionAmount: o.transaction_amount,
                from: o.from,
                status: o.status,
                isActive: o.is_active,
                transactionType: o.transaction_type,
                paymentMethod: o.payment_method,
                order: o.order,
                createdBy: o.created_by,
                createdAt: filtersHelper.getDateFormat(o.created_at),
                updatedBy: o.updated_by,
                updatedAt: filtersHelper.getDateFormat(o.updated_at)
            }
        })
    },
    [GET_TRANSACTION_REQUEST](state, data) {
        let o = data.data

        state.details = {
            uuid: o.uuid,
            paymentReferenceNumber: o.payment_reference_number,
            transactionAmount: o.transaction_amount,
            from: o.from,
            status: o.status,
            isActive: o.is_active,
            transactionType: o.transaction_type,
            paymentMethod: o.payment_method,
            order: o.order,
            createdBy: o.created_by,
            createdAt: filtersHelper.getDateFormat(o.created_at),
            updatedBy: o.updated_by,
            updatedAt: filtersHelper.getDateFormat(o.updated_at)
        }
    }
}


